import { ProtectedMeetings } from "@/views/Settings/ProtectedMeetings.tsx";

/**
 * The movable-meetings chooser, inline in a card.
 *
 * Renders the same `ProtectedMeetings` the scheduling settings screen does,
 * which is already card-shaped: no props, and it reads and writes through
 * `useFlexibleMeetings` — the same hook the omnibox card uses, so the three
 * surfaces cannot disagree about which meetings the scheduler may move.
 *
 * Each toggle saves as it is made rather than behind a Save button, so a user
 * who abandons the card keeps the meetings they already marked.
 */
export const ProtectedMeetingsPickerBody = () => <ProtectedMeetings />;
